var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrainingWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_training_word",
    transform: "translate(-393 -2171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_training_number",
    transform: "translate(-398.224 1997.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15",
    "data-name": "\\u6955\\u5186\\u5F62 15",
    transform: "translate(791.224 173.42)",
    fill: "#f5fafc",
    stroke: "#0071b9",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-tag-13",
    d: "M18.639,4.2,36,21.543,24.6,32.621,7.2,15.173V4.2H18.639ZM20.377,0H3V16.911L24.555,38.518,41.978,21.582Zm-3.61,13.765a3.145,3.145,0,1,1,0-4.445A3.148,3.148,0,0,1,16.767,13.765ZM39.873,29.31l3,2.957-18.233,18.1L3,28.716V22.77l21.719,21.6L39.873,29.31Z",
    transform: "translate(419 2196.633)",
    fill: "#0071b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingWord);
export default __webpack_public_path__ + "static/media/icon_training_word.7dbb82a79f028bdb065ff3d5d8ad132a.svg";
export { ForwardRef as ReactComponent };